












import { EAiStreamerStatus } from '@/views/CopyStake/CopyStakeAiStreamer/types';
import { IStatusMeta } from '../types';
import { STATUS_META } from '../constants';

export default {
  name: 'StatusChip',
  props: {
    status: { type: String, required: true },
    dotOnly: { type: Boolean, default: false },
    onDark: { type: Boolean, default: false }
  },
  computed: {
    meta(): IStatusMeta {
      return (
        STATUS_META[this.status as EAiStreamerStatus] ||
        STATUS_META[EAiStreamerStatus.OFFLINE]
      );
    },
    labelColor(): string {
      return this.onDark ? '#fff' : this.meta.color;
    }
  }
};
